<template>
  <div class="flex flex-col p-3">
    <!-- Filter bar -->
    <div class="flex items-center gap-3 py-2 flex-wrap">
      <select v-model="service"
              class="px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary">
        <option :value="null">-- Filter by Service --</option>
        <option value="BUSINESS_NAME">Business Name Registration</option>
        <option value="COMPANY">Company Incorporation</option>
        <option value="BUILDING_SOCIETY">Building Society</option>
      </select>
      <input type="text" v-model="brn" placeholder="Enter BRN"
             class="px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary w-48" />
      <input type="date" v-model="startDate"
             class="px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary" />
      <input type="date" v-model="endDate"
             class="px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary" />
      <button class="btn-sm-primary" @click="push" :disabled="loading">
        <i class="fa fa-upload mr-1"></i> Push
      </button>
    </div>

    <!-- Table -->
    <div>
      <table>
        <thead>
        <tr>
          <th>#</th>
          <th>BRN</th>
          <th>Name</th>
          <th>Entity Type</th>
          <th>Sub-Entity Type</th>
          <th>Status</th>
        </tr>
        </thead>
        <tbody>
        <template v-if="loading">
          <tr v-for="i in 4" :key="`sk-${i}`" class="animate-pulse">
            <td v-for="j in 6" :key="j">
              <div class="h-3 bg-gray-200 rounded"></div>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr v-for="(entity, idx) in responsePayload" :key="idx">
            <td>{{ idx + 1 }}</td>
            <td class="font-bold font-mono">{{ entity.brn }}</td>
            <td>{{ entity.name }}</td>
            <td>{{ cleanEntityType(entity.type) }}</td>
            <td>{{ cleanEntityType(entity.subType) }}</td>
            <td><span :class="statusPill(entity.status)">{{ entity.status?.toLowerCase() }}</span></td>
          </tr>
        </template>
        <tr v-if="!loading && responsePayload.length === 0">
          <td colspan="6" class="text-center py-6 text-gray-400 text-sm">No results found</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { useInternalProcessesStore } from "../stores";

const store = useInternalProcessesStore();

const loading = ref(false);
const service = ref<string | null>(null);
const brn = ref<string | null>(null);
const startDate = ref<string | null>(null);
const endDate = ref<string | null>(null);
const responsePayload = ref<any[]>([]);

const statusPill = (status: string) => {
  const base = "text-xs px-2 py-0.5 rounded-full capitalize ";
  if (status === "SENT") return base + "bg-green-50 text-green-700";
  if (status === "EXPIRED") return base + "bg-red-50 text-red-700";
  if (status === "PENDING") return base + "bg-gray-100 text-gray-600";
  if (status === "PAUSED") return base + "bg-orange-50 text-orange-600";
  return base + "bg-gray-100 text-gray-600";
};

const cleanEntityType = (name: string) => {
  if (!name) return "";
  const n = name.replaceAll("_", " ").replaceAll("-", " ");
  return n.charAt(0).toUpperCase() + n.slice(1);
};

const push = () => {
  if (!service.value) return;

  loading.value = true;

  if (service.value === "BUSINESS_NAME") {
    store.registrationPushToNameCheck({ brn: brn.value, startDate: startDate.value, endDate: endDate.value });
  } else if (service.value === "COMPANY") {
    store.incorporationPushToNameCheck({ brn: brn.value, startDate: startDate.value, endDate: endDate.value });
  } else if (service.value === "BUILDING_SOCIETY") {
    store.buildingSocietyPushToNameCheck(brn.value);
  }
};

watch(() => store.incorporationNameCheck, (data) => {
  if (data) {
    loading.value = false;
    responsePayload.value = data.data ?? [];
  }
});

watch(() => store.registrationNameCheck, (data) => {
  if (data) {
    loading.value = false;
    responsePayload.value = data.data ?? [];
  }
});

watch(() => store.buildingSocietyNameCheck, (data) => {
  if (data) {
    loading.value = false;
    responsePayload.value = data.data ?? [];
  }
});

watch(() => store.incorporationNameCheckError, (data) => {
  if (data) loading.value = false;
});

watch(() => store.registrationNameCheckError, (data) => {
  if (data) loading.value = false;
});

watch(() => store.buildingSocietyNameCheckError, (data) => {
  if (data) loading.value = false;
});
</script>
